import {
  CLOSE_CREATE_LEAD_MODAL,
  OPEN_CREATE_LEAD_MODAL,
  OPEN_UPDATE_LEAD_MODAL,
  START_LOADING,
  STOP_LOADING,
  CREATE_LEAD_SUCCESS,
  CREATE_LEAD_FAILURE,
  ALL_LEADS_SUCCESS,
  SEARCH_LEAD_SUCCESS,
  SEARCH_LEAD_FAILURE,
  GET_DELTED_LEAD_SUCCESS
} from "../actions/actionTypes";

const initialState = {
  allLeads: {},
  leadsById:{},
  searchLeads: [],
  searchLeadsReport:[],
  loading: false,
  error: null,
  isCreateLeadModalOpen: false,
  selectedLeadId: null,
};

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };

    case STOP_LOADING:
      return { ...state, loading: false };

    case CREATE_LEAD_SUCCESS:
    case ALL_LEADS_SUCCESS:
      return { ...state, allLeads: action.payload, error: null };
    case "GETBYID_LEADS_SUCCESS":
      return { ...state, leadsById: action.payload, error: null };
     case "RESET_ALL_LEADS":
      return { ...state, leadsById: {}, error: null };

    case SEARCH_LEAD_SUCCESS:
      return { ...state, searchLeads: action.payload, error: null };
    case "SEARCH_LEAD_REPORT_SUCCESS":
      return { ...state, searchLeadsReport: action.payload, error: null };

    case SEARCH_LEAD_FAILURE:
    case CREATE_LEAD_FAILURE:
      return { ...state, error: action.payload };

    case GET_DELTED_LEAD_SUCCESS:
      // Optional: handle deleted lead result if needed
      return state;

    case OPEN_CREATE_LEAD_MODAL:
      return { ...state, isCreateLeadModalOpen: true };

    case CLOSE_CREATE_LEAD_MODAL:
      return { ...state, isCreateLeadModalOpen: false };

    case OPEN_UPDATE_LEAD_MODAL:
      return { ...state, selectedLeadId: action.payload };

    default:
      return state;
  }
};

export default leadReducer;
